import ExamAttemptExpiredModal from '../../../components/Modals/StatusUpdateModals/ExamAttemptExpiredModal';
import { useExpiredModalState } from '../examsStores';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExamLayout = ({
  children
}) => {
  const {
    showExpiredModal,
    setShowExpiredModal
  } = useExpiredModalState();
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "exam-container",
    children: /*#__PURE__*/_jsxs("div", {
      children: [showExpiredModal && /*#__PURE__*/_jsx(ExamAttemptExpiredModal, {
        onView: () => setShowExpiredModal(false)
      }), children]
    })
  });
};
export default ExamLayout;